<template>
    <div class="inbox-message message-outbound conversation-note" style="background: #fffcdc;">
        <div class="message-body">
            <tiptap-message-field v-model="content" :disabled="isSaving" />
            <div class="row" style="margin-top: 1rem;">
                <div class="col">
                    <ui-icon-button
                        type="secondary"
                        icon="delete"
                        :disabled="isSaving"
                        @click="$emit('reset')"
                    />
                </div>
                <div class="col text-right">
                    <ui-button
                        color="orange"
                        :loading="isSaving"
                        @click="save"
                    >Save Note</ui-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {NoteResource} from "../../classes/Api/Note";
    import TiptapMessageField from "./TiptapMessageField.vue";

    export default {
        components: {TiptapMessageField},
        data() {
            return {
                isSaving: false,
                content: ''
            }
        },
        methods: {
            save() {
                this.isSaving = true

                let data = {
                    content: this.content,
                    owners: [
                        'contact:' + this.$store.getters['inbox/conversations/conversation'].contact.id,
                        'inbox.conversation:' + this.$store.getters['inbox/conversations/conversation'].id
                    ]
                }

                NoteResource.store(data).then(() => {
                    this.$emit('saved')
                }).finally(() => {
                    this.isSaving = false
                })
            }
        }
    }
</script>

<style lang="scss">
    @import 'message-styles';

    .conversation-note {
        .message-body { padding-top: 2rem; }

        .message-quill-editor {
            .ql-container .ql-editor {
                min-height: 100px;
            }
        }
    }
</style>